export default "__VITE_ASSET__BsNCB5ZE__"